module.exports = __webpack_public_path__ + "img/SCPG_icon.a13c6001.png";